export interface ISubjectFrontEndModel {
  id: number;
  name: string;
  category: string;
}

export enum TeacherDetailTypeEnum {
  Bio = 1,
  Education = 2,
  Experience = 3,
  Calendar = 4,
}

export interface IPrivateClassListItemFrontEndModel {
  id: string;
  subjectId: number;
  teachingLanguage: string;
}

export interface IPrivateClassListItemBackEndModel {
  id: string;
  subjectId: number;
  teachingLanguage: string;
}

export interface IPrivateClassSubject {
  id: number;
  name: string;
  category: string;
}

export interface IPrivateClassBackEndModel {
  id: string;
  teacherId?: string;
  subjectId: number;
  teachingLanguage: string;
  description: string;
  extraFiles?: {
    fileId: string;
  }[];
}

export interface IManagePrivateClassFormModel {
  id: string;
  teacherId?: string;
  subjectId: number;
  teachingLanguage: string;
  description: string;
  extraFiles?: {
    id: string;
    name: string;
    size: number;
    preview: string;
    fileId: string;
  }[];
}

export interface IDetailsViewModel {
  content: string;
  type: number;
  name: string;
}

export interface IGetPrivateClassFrontEndModel {
  id: string;
  subjectName: string;
  teachingLanguage: string;
  description: string;
  extraFiles?: {
    id: string;
    fileId: string;
    name: string;
    size: number;
    path: string;
  }[];
}

export interface IGetPrivateClassBackEndModel {
  id: string;
  subjectId: number;
  teachingLanguage: string;
  description: string;
  extraFiles?: {
    id: string;
    fileId: string;
    name: string;
    size: number;
    path: string;
  }[];
}

// TODO: remove redundant types
//***************** Interfaces *****************//

export interface IDetailFileFrontEndModel {
  id: string;
  name: string;
  size: number;
  path: string;
}

export interface IDetailFileBackEndModel {
  name: string;
  size: number;
  path: string;
}

export interface IViewServiceModel {
  serviceTypeName: string;
  countries: string;
  details: IDetailsViewModel[];
  detailFiles: IDetailFileFrontEndModel[];
}

export interface IPrivateClassTeacherBackEndModel {
  fullName: string;
  profilePicture: string;
  country: string;
  bio: string;
  education: string;
  experience: string;
  calendar: string | null;
  certificates: { name: string; path: string; size: number }[];
  cv: { name: string; path: string; size: number } | null;
}

export interface IViewMorePrivateClassBackEndModel {
  id: string;
  teacherId: string;
  subjectName: string;
  teachingLanguage: string;
  description: string;
  extraFiles: { name: string; path: string; size: number }[];
  teacher: IPrivateClassTeacherBackEndModel;
}

export interface IViewMoreContactsBackEndModel {
  phone: string;
  email: string;
  website: string;
}

export interface IPrivateClassViewMoreFrontEndModel {
  id: string;
  teacherId: string;
  subjectName: string;
  teachingLanguage: string;
  description: string;
  extraFiles: { name: string; path: string; size: number }[];
  teacher: IPrivateClassTeacherBackEndModel;
  details: { name: string; content: string; type: number }[];
}